import {
  isCVV,
  isCreditCardNumber,
  isEmpty,
  isEmail,
  isCPForCNPJ,
  isMobile,
  isCPF,
} from '../helpers/validation';

export const useError = () => {
  const goToFieldWithError = (id) => {
    const element = document.getElementById(id);
    let offset = 150;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    const offsetPosition = elementPosition - offset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    document.getElementById(id).focus();
  };

  const attendeeError = {
    name: (attendee) => !isEmpty(attendee.name),
    namebadge: (attendee) => !isEmpty(attendee.namebadge),
    email: (attendee) => isEmail(attendee.email),
    document: (attendee) => isCPF(attendee.document),
    mobile: (attendee) => isMobile(attendee.mobile),
    address: (attendee) => !isEmpty(attendee.address),
    state: (attendee) => !isEmpty(attendee.state),
    city: (attendee) => !isEmpty(attendee.city),
    company: (attendee) => !isEmpty(attendee.company),
    role: (attendee) => !isEmpty(attendee.role),
    term1: (attendee) => attendee.term1,
  };

  const cctokenError = {
    number: (cctoken) => isCreditCardNumber(cctoken.number),
    name: (cctoken) => !isEmpty(cctoken.name),
    country: (cctoken) => !isEmpty(cctoken.country),
    expireAt: (cctoken) => !isEmpty(cctoken.expireAt),
    code: (cctoken) => isCVV(cctoken.code),
  };

  const customerError = {
    name: (customer) => !isEmpty(customer.name),
    document: (customer) => isCPForCNPJ(customer.document),
    email: (customer) => isEmail(customer.email),
  };
  return {
    attendeeError,
    customerError,
    cctokenError,
    goToFieldWithError,
  };
};
